<template>
  <div
    class="method-tab d-flex align-items-center justify-content-center cursor-pointer"
    :class="{ active: active }"
    :style="tabStyle"
    @click="$emit('active')"
  >
    <template v-if="paymentMethod == 'paypal'">
      <img
        src="https://cdn.vexels.com/img/paypal-logo.png"
        :alt="$t('purchase.payment.common.paypalAlt')"
        class="my-1 paypal-logo"
        loading="lazy"
      />
    </template>
    <template v-else-if="paymentMethod == 'stripe'">
      <Icon :width="40" :height="40" icon="credit-card" color="#7069FE" />
      <span class="ml-2 tab-text">{{ $t('purchase.payment.common.stripe') }}</span>
      <img
        src="https://cdn.vexels.com/img/stripe.png"
        :alt="$t('purchase.payment.common.paypalAlt')"
        class="my-2 stripe-logo"
        loading="lazy"
      />
    </template>
    <template v-else>
      <Icon :width="40" :height="40" icon="credit-card" color="#676767" />
      <span class="ml-2 tab-text">{{ $t('purchase.payment.common.creditCard') }}</span>
    </template>
  </div>
</template>

<script>
import Icon from 'UI/Icon';

export default {
  components: {
    Icon
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    paymentMethod: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    tabStyle() {
      return `width:${100 / (this.options?.length || 1)}%`;
    }
  }
};
</script>

<style lang="scss" scoped>
.method-tab {
  background-color: #f2f2f2;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.method-tab.active {
  background-color: white;
}
.tab-text {
  font-size: 14px;
}
.paypal-logo {
  height: 50px;
}
.stripe-logo {
  height: 30px;
}
</style>
